import { defineComponent as o, createBlock as r, openBlock as l, unref as p, mergeProps as c, withCtx as i, createElementVNode as a } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const d = /* @__PURE__ */ o({
  name: "IconRepairMailIn",
  __name: "IconRepairMailIn",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (s, e) => (l(), r(p(m), c(n, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        a("path", { d: "M5.5 6.5V16h4.75a.75.75 0 0 1 0 1.5h-5A1.25 1.25 0 0 1 4 16.25v-10A1.25 1.25 0 0 1 5.25 5h13.5A1.25 1.25 0 0 1 20 6.25V8a.75.75 0 0 1-1.5 0V6.5H14v3.8a.3.3 0 0 1-.415.277l-1.47-.612a.3.3 0 0 0-.23 0l-1.47.612A.3.3 0 0 1 10 10.3V6.5H5.5" }, null, -1),
        a("path", { d: "M20.683 14.81c-.837.836-2.263 1.082-3.404.575l-5.082 5.082a1 1 0 1 1-1.414-1.414l5.082-5.083c-.507-1.14-.261-2.566.575-3.403 1.002-1.001 2.358-.939 3.064-.817.22.038.286.296.128.454l-1.69 1.69a.3.3 0 0 0-.088.212v.99a.3.3 0 0 0 .3.3h.99a.3.3 0 0 0 .212-.088l1.69-1.69c.158-.158.416-.092.454.128.122.706.184 2.063-.817 3.064" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
